<script lang="ts">
	import { page } from '$app/state';
	import * as Collapsible from '$lib/components/ui/collapsible/index.js';
	import UsersIcon from '@lucide/svelte/icons/users';
	import { getSharedSessions, sharedLoaded } from '$lib/shared-sessions-store.svelte';
	import { sharedViewerHref } from '$lib/shared-routing';

	const shared = getSharedSessions();
	const sidebarShared = $derived(shared.filter((s) => s.sidebarVisible !== false));

	// Highlight the active shared chat. The viewer route is /shared/<owner>/<id>.
	const activeShared = $derived.by(() => {
		const m = page.url.pathname.match(/^\/shared\/[^/]+\/([^/]+)/);
		return m ? decodeURIComponent(m[1]) : null;
	});

	function ownerLabel(s: { ownerName: string | null; ownerSub: string }): string {
		return s.ownerName?.trim() || s.ownerSub;
	}
</script>

{#if sharedLoaded() && sidebarShared.length > 0}
	<Collapsible.Root open class="px-0">
		<Collapsible.Trigger
			class="group/shared mt-2 flex w-full items-center gap-1.5 px-3.5 pt-1 pb-1 text-left text-[10.5px] font-medium uppercase tracking-wider text-[color:var(--fg-faint)] transition-colors hover:text-sidebar-foreground focus-visible:outline-none"
		>
			<UsersIcon class="size-3" aria-hidden="true" />
			<span class="flex-1">Shared with me</span>
			<span
				class="text-[10px] transition-transform group-data-[state=open]/shared:rotate-90"
				aria-hidden="true">›</span
			>
		</Collapsible.Trigger>
		<Collapsible.Content>
			<ul class="flex flex-col gap-px px-2">
				{#each sidebarShared as s (s.ownerSub + '::' + s.sessionId)}
					{@const isActive = s.sessionId === activeShared}
					{@const href = sharedViewerHref(s.ownerSub, s.sessionId)}
					<li class="group relative">
						<a
							{href}
							aria-current={isActive ? 'page' : undefined}
							class="flex cursor-pointer flex-col gap-[1px] rounded-md px-2.5 py-[7px] transition-colors hover:bg-[color:var(--surface-2,var(--secondary))] aria-[current=page]:bg-sidebar-accent aria-[current=page]:text-sidebar-accent-foreground focus-visible:bg-[color:var(--secondary)] focus-visible:outline-none"
						>
							<span class="truncate text-[12.5px] font-medium">
								{s.title?.trim() || s.sessionId.slice(0, 8)}
							</span>
							<span class="truncate text-[10.5px] text-[color:var(--fg-faint)]">
								shared by {ownerLabel(s)}
							</span>
						</a>
					</li>
				{/each}
			</ul>
		</Collapsible.Content>
	</Collapsible.Root>
{/if}
